//根据不同的环境更改不同的baseUrl
let baseUrl = '';

//开发环境下
if (process.env.NODE_ENV == 'development') {
  baseUrl = 'http://192.168.100.209:8180';//测试环境
  // baseUrl = 'http://192.168.97.111:8087';
  // baseUrl = 'http://192.168.97.124:8080';
  // baseUrl = 'http://192.168.97.114:8180';//邓世荡本地
  // baseUrl = 'http://192.168.97.105:8180';//苏太本地 

} else if (process.env.NODE_ENV == 'production') {

  // baseUrl = 'http://192.168.100.209:8180';//测试环境打包
  // baseUrl = '/hn-api';
  baseUrl = 'https://www.honengelec.com/hn-api';

} else if (process.env.NODE_ENV == 'staging') {

  baseUrl = 'http://192.168.100.209:8180';
  // baseUrl = '/hn-api';
}

export {
  baseUrl,//导出baseUrl
}
